import { useState, useEffect } from 'react';

export const useGameState = () => {
  const [currentGame, setCurrentGame] = useState(null);
  const [gameHistory, setGameHistory] = useState([]);
  const [language, setLanguage] = useState('nl'); // Default to Dutch since it's a Dutch game

  // Load data from localStorage on mount
  useEffect(() => {
    try {
      const savedHistory = localStorage.getItem('rikken-game-history');
      const savedLanguage = localStorage.getItem('rikken-language');
      const savedCurrentGame = localStorage.getItem('rikken-current-game');
      
      if (savedHistory) {
        setGameHistory(JSON.parse(savedHistory));
      }
      if (savedLanguage) {
        setLanguage(savedLanguage);
      }
      if (savedCurrentGame) {
        setCurrentGame(JSON.parse(savedCurrentGame));
      }
    } catch (error) {
      console.error('Error loading saved game data:', error);
    }
  }, []);

  // Save to localStorage when data changes
  useEffect(() => {
    try {
      localStorage.setItem('rikken-game-history', JSON.stringify(gameHistory));
    } catch (error) {
      console.error('Error saving game history:', error);
    }
  }, [gameHistory]);

  useEffect(() => {
    try {
      localStorage.setItem('rikken-language', language);
    } catch (error) {
      console.error('Error saving language:', error);
    }
  }, [language]);

  useEffect(() => {
    try {
      if (currentGame) {
        localStorage.setItem('rikken-current-game', JSON.stringify(currentGame));
      } else {
        localStorage.removeItem('rikken-current-game');
      }
    } catch (error) {
      console.error('Error saving current game:', error);
    }
  }, [currentGame]);

  const addGameToHistory = (game) => {
    setGameHistory(prev => [game, ...prev]);
  };

  const clearCurrentGame = () => {
    setCurrentGame(null);
  };

  return {
    currentGame,
    setCurrentGame,
    gameHistory,
    setGameHistory,
    addGameToHistory,
    clearCurrentGame,
    language,
    setLanguage
  };
};
